var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8671_527407",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 25.6004C21.3019 25.6004 25.6 21.3023 25.6 16.0004C25.6 10.6985 21.3019 6.40039 16 6.40039C10.6981 6.40039 6.4 10.6985 6.4 16.0004C6.4 21.3023 10.6981 25.6004 16 25.6004Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 25.6004C21.3019 25.6004 25.6 21.3023 25.6 16.0004C25.6 10.6985 21.3019 6.40039 16 6.40039C10.6981 6.40039 6.4 10.6985 6.4 16.0004C6.4 21.3023 10.6981 25.6004 16 25.6004Z",
    fill: "#969FA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.2843 24.2843 31 16 31V33C25.3888 33 33 25.3888 33 16H31ZM16 1C24.2843 1 31 7.71573 31 16H33C33 6.61116 25.3888 -1 16 -1V1ZM1 16C1 7.71573 7.71573 1 16 1V-1C6.61116 -1 -1 6.61116 -1 16H1ZM16 31C7.71573 31 1 24.2843 1 16H-1C-1 25.3888 6.61116 33 16 33V31ZM24.6 16.0004C24.6 20.75 20.7496 24.6004 16 24.6004V26.6004C21.8542 26.6004 26.6 21.8546 26.6 16.0004H24.6ZM16 7.40039C20.7496 7.40039 24.6 11.2507 24.6 16.0004H26.6C26.6 10.1462 21.8542 5.40039 16 5.40039V7.40039ZM7.4 16.0004C7.4 11.2507 11.2504 7.40039 16 7.40039V5.40039C10.1458 5.40039 5.4 10.1462 5.4 16.0004H7.4ZM16 24.6004C11.2504 24.6004 7.4 20.75 7.4 16.0004H5.4C5.4 21.8546 10.1458 26.6004 16 26.6004V24.6004Z",
    fill: "white",
    mask: "url(#path-1-inside-1_8671_527407)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 16.6667H16.6663V20.6667H15.333V16.6667H11.333V15.3334H15.333V11.3334H16.6663V15.3334H20.6663V16.6667Z",
    fill: "#969FA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.7518589345803c48e67be6fdec6c28db.svg";
export { ForwardRef as ReactComponent };